/**
 * Generated by orval v7.20.0 🍺
 * Do not edit manually.
 * MALIYONE-LOAN-MANAGEMENT-API API
 * API specification for MALIYONE-LOAN-MANAGEMENT-API
 * OpenAPI spec version: 1.0.0
 */

/**
 * Type of work item/task
 */
export type BpmTaskWorkItemType = typeof BpmTaskWorkItemType[keyof typeof BpmTaskWorkItemType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BpmTaskWorkItemType = {
  VERIFY_DOCUMENTS: 'VERIFY_DOCUMENTS',
  CREDIT_ASSESSMENT: 'CREDIT_ASSESSMENT',
  CAPTURE_APPLICATION: 'CAPTURE_APPLICATION',
  UPLOAD_AGREEMENT: 'UPLOAD_AGREEMENT',
  UPLOAD_DOCUMENTS: 'UPLOAD_DOCUMENTS',
  VERIFY_COLLATERAL: 'VERIFY_COLLATERAL',
  DISBURSE_FUNDS: 'DISBURSE_FUNDS',
  REVIEW_APPLICATION: 'REVIEW_APPLICATION',
  APPROVE_LOAN: 'APPROVE_LOAN',
  PROCESS_LEAD: 'PROCESS_LEAD',
} as const;
